// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__c9dRL","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__ANdlp"};